import React, {useState} from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import carwashImg from '../images/carwash.jpg';
import detailingImg from '../images/detailing.jpg';

const TayMarDetailing = () => {
    return (
        <div className="min-h-screen pt-[15vh] bg-gradient-to-br from-blue-800 to-blue-300 flex items-center justify-center p-4">
            <div className="max-w-5xl w-full bg-white/90 backdrop-blur-lg rounded-2xl shadow-2xl p-8 transform transition-all hover:shadow-3xl">
                {/* Header */}
                <div className="text-center mb-10">
                    <h1 className="text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent mb-4 animate-fade-in">
                        TMJ Auto Spa Special Promotion
                    </h1>
                    <p className="text-xl text-gray-700 mb-6 bg-white/80 rounded-xl p-4 shadow-sm">
                        <strong className="text-2xl text-blue-800">Attention Burlington County and surrounding areas!</strong> Experience convenience and savings with TMJ Auto Spa.<strong>We come to you </strong> delivering luxury mobile car wash and detailing services. Check out our promotions below and take advantage of our limited time deals!
                    </p>
                </div>

                {/* Single Service and Add-Ons Card */}
                <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-8 mb-12 border-2 border-blue-100">
                    <h2 className="text-3xl font-bold text-center bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent mb-8">
                        Single Service + Add-Ons
                    </h2>

                    {/* Service Options */}
                    <div className="grid md:grid-cols-2 gap-8 mb-12">
                        {/* Mobile Car Wash */}
                        <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                            <div className="flex justify-center gap-4 items-center mb-4">
                                <span className="text-2xl font-bold text-gray-500 line-through">$45</span>
                                <span className="text-2xl font-bold text-green-600 bg-green-100 px-4 py-2 rounded-full">$25 Promo</span>
                            </div>
                            <h3 className="text-2xl font-semibold text-gray-800 mb-2">Mobile Car Wash</h3>
                            <p className="text-gray-600 mb-4">(Includes tires, windows, and lights)</p>
                            <img src={carwashImg} alt="Car Wash" className="w-full h-48 object-cover rounded-lg shadow-md transform transition hover:scale-105" />
                        </div>

                        {/* Mobile Detailing */}
                        <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                            <div className="flex justify-center gap-4 items-center mb-4">
                                <span className="text-2xl font-bold text-gray-500 line-through">$50</span>
                                <span className="text-2xl font-bold text-green-600 bg-green-100 px-4 py-2 rounded-full">$30 Promo</span>
                            </div>
                            <h3 className="text-2xl font-semibold text-gray-800 mb-2">Interior Detail</h3>
                            <p className="text-gray-600 mb-4">(Includes surface & screen cleaning, Vacuum, & Windows)</p>
                            <img src={detailingImg} alt="Interior Detailing" className="w-full h-48 object-cover rounded-lg shadow-md transform transition hover:scale-105" />
                        </div>
                    </div>

                    {/* Add-Ons Section */}
                    <div className="space-y-6">
                        <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Available Add-Ons</h3>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {[
                                { name: 'Pet Hair Removal', original: 20, promo: 10 },
                                { name: 'Graphene Body Coat', original: 40, promo: 20 },
                                { name: 'RainX and Rim Protector', original: 40, promo: 20 },
                                { name: 'Seat Cleaning', original: 20, promo: 10 },
                                { name: 'Interior Condition & Protect', original: 10, promo: 5 },
                                { name: 'Tire Shine', original: 10, promo: 5 },
                                { name: 'Wax & Buff Shine', original: 40, promo: 25 },
                                { name: 'Air Freshener', original: 5, promo: 0 },
                            ].map((service, index) => (
                                <div key={index} className="bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-transform transform hover:-translate-y-1">
                                    <div className="text-center">
                                        <h4 className="font-semibold text-gray-800 mb-2">{service.name}</h4>
                                        <div className="space-y-1">
                                            <span className="text-gray-500 line-through">${service.original}</span>
                                            <span className="block text-xl font-bold text-green-600">
                                                ${service.promo} {service.promo === 0 && 'FREE'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* MOAM Special */}
                            <div className="col-span-full bg-amber-50 p-4 rounded-xl shadow-lg border-2 border-amber-200">
                                <div className="text-center">
                                    <h4 className="text-xl font-bold text-amber-800 mb-2">MOAM (Mother.Of.All.Messes)</h4>
                                    <p className="text-sm text-amber-700 mb-2">For major stains, sticky substances, lingering odors, etc</p>
                                    <div className="text-2xl font-bold text-amber-800">
                                        <span className="line-through text-gray-500">+$65</span>
                                        <span className="ml-2">+$50</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Service Comparison Chart */}
                <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-8 mb-12 border-2 border-blue-100">
                    <h2 className="text-3xl font-bold text-center bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent mb-8">
                        Service Packages
                    </h2>
                    {/* Service Comparison Chart */}
                    <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-8 mb-12 border-2 border-blue-100">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            {/* Header Row */}
                            <div className="hidden md:block"></div>
                            {['Value', 'Premium', 'Luxury'].map((tier, index) => (
                                <div key={index} className="bg-gradient-to-b from-blue-50 to-white p-4 rounded-xl text-center shadow-md">
                                    <h3 className="text-xl font-bold text-gray-800 mb-2">{tier}</h3>
                                    <div className="space-y-1">
                                        <span className="line-through text-gray-500">
                                            ${[75, 100, 125][index]}
                                        </span>
                                        <span className="block text-2xl font-bold text-green-600">
                                            ${[50, 75, 100][index]}
                                        </span>
                                    </div>
                                </div>
                            ))}

                            {/* Feature Rows */}
                            {[
                                { label: 'Exterior Wash + Dry', values: [true, true, true] },
                                { label: 'Interior Vacuum + surface cleaning', values: [true, true, true] },
                                { label: 'Window Cleaning', values: [true, true, true] },
                                { label: 'Rim & Tire Shine', values: [false, true, true] },
                                { label: 'Rain-X / Rim Protectant', values: [false, true, true] },
                                { label: 'Interior Conditioning & Protectant', values: [false, false, true] },
                                { label: 'Hand Wax + Buff', values: [false, false, true] },
                                { label: '$3 Add-Ons', values: [false, false, true] },
                                { label: 'Graphene Coat', values: [false, false, true] },
                            ].map((row, index) => (
                                <React.Fragment key={index}>
                                    <div className="font-semibold text-gray-800 p-3 bg-blue-50 rounded-l-xl">
                                        {row.label}
                                    </div>
                                    {row.values.map((val, i) => (
                                        <div key={i} className="text-center p-3 bg-white">
                                            {val ? (
                                                <CheckCircle className="w-6 h-6 text-green-500 mx-auto" />
                                            ) : (
                                                <XCircle className="w-6 h-6 text-red-400 mx-auto" />
                                            )}
                                        </div>
                                    ))}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Subscription Plans */}
                <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-8 mb-12 border-2 border-blue-100">
                    <h2 className="text-3xl font-bold text-center bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent mb-8">
                        Subscription Plans
                    </h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {
                        [
                            {
                              tier: 'Value',
                              color: 'blue',
                              price: 150,
                              regPrice: '$225',
                              savings: 75,
                              features: [
                                '1 wash/week or 4 per month',
                                'Extra washes: $10 each',
                                'Quarterly: $450 ($225 savings)',
                                'Yearly: $1,800 ($900 savings)'
                              ],
                              description: 'Basic upkeep for budget-friendly care'
                            },
                            {
                              tier: 'Premium',
                              color: 'yellow',
                              price: 300,
                              regPrice: '$400',
                              savings: 100,
                              features: [
                                '1 wash/week + interior clean',
                                'Extra washes: $5 each',
                                'Quarterly: $900 ($300 savings)',
                                'Yearly: $3,600 ($1,200 savings)'
                              ],
                              description: 'Upgraded care & better value'
                            },
                            {
                              tier: 'Luxury',
                              color: 'green',
                              price: 385,
                              regPrice: '$500',
                              savings: 115,
                              features: [
                                'Weekly Luxury Package',
                                'Extra washes: $2 each',
                                'Quarterly: $1,155 ($345 savings)',
                                'Yearly: $4,620 ($1,380 savings)'
                              ],
                              description: 'Top-tier experience & maximum savings'
                            }
                          ].map((plan, index) => (
                            <div key={index} className={`border-2 border-${plan.color}-300 bg-gradient-to-b from-${plan.color}-50 to-white rounded-xl p-6 
                                hover:shadow-xl transition-all ${index === 2 ? 'transform scale-105' : ''}`}>
                                <p className="text-2xl font-bold text-gray-800 mb-2">{plan.tier}</p>
                                <div className="mb-4">
                                    <p className="text-xs line-through text-gray-500">{plan.regPrice}</p>
                                    <p className={`text-4xl font-black text-${plan.color}-600 mb-1`}>
                                        ${plan.price}<span className="text-sm">/mo</span>
                                    </p>
                                    <p className="text-lg font-bold text-green-600">(${plan.savings} savings)</p>
                                </div>
                                <ul className="space-y-2 mb-4">
                                    {plan.features.map((feature, i) => (
                                        <li key={i} className="text-sm text-gray-700">✓ {feature}</li>
                                    ))}
                                </ul>
                                <p className={`text-xs text-${plan.color}-700 font-medium`}>{plan.description}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-8 text-center bg-blue-50 p-4 rounded-xl">
                        <p className="text-gray-700">
                            Custom Budget plans available starting at $80/month - Contact our team to create your perfect plan
                        </p>
                    </div>
                </div>

                {/* Why Choose Us */}
                <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-8 border-2 border-blue-100">
                    <h2 className="text-3xl font-bold text-center bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent mb-8">
                        Why Choose TMJ Auto Spa?
                    </h2>

                    <div className="grid md:grid-cols-2 gap-6 mb-8">
                        {[
                            'Convenient, on-location service that saves you time',
                            'Professional detailing that enhances your vehicle’s appearance',
                            'Transparent pricing & customizable options',
                            'Hassle-free scheduling process'
                        ].map((point, index) => (
                            <div key={index} className="bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition">
                                <div className="flex items-center gap-3">
                                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                        <CheckCircle className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <p className="text-gray-700">{point}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center">
                        <a href='/detailquote'>
                            <button className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-8 py-4 rounded-full font-bold 
                                shadow-lg hover:shadow-xl transition-all transform hover:scale-105">
                                Book Your Appointment Now
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TayMarDetailing;